<template>
    <hmenu></hmenu>

          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title">Lista e Ngjarjeve</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ns-blog-area ns-blog-page pt-45 pb-25 ">
              <div class="container">
                  <div class="row">
                      <div v-for="blog in blogs" class="col-xl-4 col-lg-6 col-md-6">
                        <div class="ns-blog-item mb-30">
                            <div class="ns-blog-img w_img">
                                <router-link :to="{ name: 'blogDetails', params: { slug: blog.slug }  }">
                                  <img :src="'/asetet/projects/'+blog.cover_image">
                                </router-link>
                                <span class="ns-blog-tag">{{blog.category}}</span>
                                <span class="ns-blog-img-shape-1"></span>
                                <span class="ns-blog-img-shape-2"></span>
                            </div>
                            <div class="ns-blog-content">
                                <h3 class="ns-blog-content-title">
                                  <router-link :to="{ name: 'blogDetails', params: { slug: blog.slug }  }">
                                    <span v-html="blog.title"></span>
                                  </router-link>
                                </h3>
                                <a href="blog-details.html" class="ns-blog-btn">Me shumë<i class="icofont-plus"></i></a>
                                <span class="ns-blog-shape-1"></span>
                                <span class="ns-blog-shape-2"></span>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
            </section>
              
        </main>

    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    import blogService from "@/api/blogService";

    export default {

        data () {
          return {
            selected:'info',
            blogs:[]
          }
        },


        components: {

          hmenu,
          Footer,
          blogService,
         
        },


        methods:{

          tabClick(type){
            this.selected = type
          },

          async loadBlogs(){

            try {
              let response = await blogService.getBlogs();
              this.blogs = response.data.data;
            }catch(error){
              console.log(error);
            }

          }

        },

        mounted(){

          this.loadBlogs();
          window.scrollTo({top: 0, behavior: 'smooth'});

        },



    }

</script>



<style>


  .ns-project-details-listt ul li {
      display: flex;
      align-items: center;
      line-height: 1;
      margin-bottom: 20px;
      gap: 5px;
      font-size: 17px;
      color: var(--clr-body-text);
  }



  .kioska__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }


  .hyrja__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }

  .para li{
    flex-wrap: wrap!important;
  }

</style>